<script>
    // Stores 
	import { 
		textSite 

	} from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import ListaImoveis from './../components/ListaImoveis.svelte'
	import PageHeader from './../components/PageHeader.svelte'

    // Code
    let titlePage = 'Favoritos';  	

	//Carrega bookmarks
	atria.loadBookmarks();

	let filtrosRent = {nt:atria.rent, pageSize:30, id:atria.bookmarks.Rent.join(',')};
	let filtrosRentExtra = {nt:atria.rentExtra, pageSize:30, id:atria.bookmarks.RentExtra.join(',')};
	let filtrosSell = {nt:atria.sell, pageSize:30, id:atria.bookmarks.Sell.join(',')};
	let showFavoritos = true;

	if (atria.bookmarks.Rent.length === 0) {
		filtrosRent.id = 'SEM_FAVORITOS';
	}
	
	if (atria.bookmarks.RentExtra.length === 0) {
		filtrosRentExtra.id = 'SEM_FAVORITOS';
	}

	if (atria.bookmarks.Sell.length === 0) {
		filtrosSell.id = 'SEM_FAVORITOS';
	}

	if (filtrosRent.id === 'SEM_FAVORITOS' && filtrosRentExtra.id === 'SEM_FAVORITOS' && filtrosSell.id === 'SEM_FAVORITOS') {
		showFavoritos = false;
	}

	function clearBookmarks() {
		atria.clearBookmarks();

		filtrosRent = {nt:atria.rent, pageSize:30, id:'SEM_FAVORITOS'};
		filtrosRentExtra = {nt:atria.rentExtra, pageSize:30, id:'SEM_FAVORITOS'};
		filtrosSell = {nt:atria.sell, pageSize:30, id:'SEM_FAVORITOS'};

		showFavoritos = false;
		numberOfItems = 0;

		numberOfItemsForSell = 0;
		numberOfItemsForRent = 0;
		numberOfItemsForRentExtra = 0;
	}

	$: numberOfItems = 0;
	$: numberOfItemsForSell = 0;
	$: numberOfItemsForRent = 0;
	$: numberOfItemsForRentExtra = 0;
	function afterLoadRealties(json) {
		if (json != null && !json.Error) {
			numberOfItems += json.NumberOfItems;

			if (json.Items.length > 0) {
				if (json.Items[0].CurrentNegotiationTypeId == atria.sell) {
					numberOfItemsForSell = json.Items.length;
				} else if (json.Items[0].CurrentNegotiationTypeId == atria.rent) {
					numberOfItemsForRent = json.Items.length;
				} else if (json.Items[0].CurrentNegotiationTypeId == atria.rentExtra) {
					numberOfItemsForRentExtra = json.Items.length;
				}
			}
		}
	}

	let buttons = [
		{
			name: 'Limpar Lista',
			icon: `<i class="far fa-ban"></i>`,
			href: 'javascript:void(0);',
			onClick: clearBookmarks
		},
		{
			name: 'Enviar para a Imobiliária',
			icon: `<i class="far fa-envelope"></i>`,
			href: `/favoritos-imobiliaria`,
		},
		{
			name: 'Enviar para Amigo',
			icon: `<i class="far fa-paper-plane"></i>`,
			href: '/favoritos-amigo',
		}
	];

	if (!showFavoritos || numberOfItems == 0) {
		buttons = [];
	}
	
</script>

<PageHeader title={titlePage} buttons={buttons}></PageHeader>


<div class="container">
{#if showFavoritos}
	<p>Confira sua lista de imóveis favoritos.</p>
	<section class="section lista-imoveis pt-0 {numberOfItemsForRent == 0 ? 'hide':''}" >
		{#if numberOfItemsForRent > 0}
		<h3>Imóveis para alugar</h3>
		{/if}
		<ListaImoveis holderClass="grid grid-size--3 grid-size-md--3 grid-size-sm--2 grid-size-xs--1" colClass="item" filters={filtrosRent} afterLoadRealties={afterLoadRealties} showPaginator={false} notFoundClass="hide" />
		<br />
	</section>
	<section class="section lista-imoveis pt-0 {numberOfItemsForRentExtra == 0 ? 'hide':''}" >
		{#if numberOfItemsForRentExtra > 0}
		<h3>Imóveis para alugar por temporada</h3>
		{/if}
		<ListaImoveis holderClass="grid grid-size--3 grid-size-md--3 grid-size-sm--2 grid-size-xs--1" colClass="item" filters={filtrosRentExtra} afterLoadRealties={afterLoadRealties} showPaginator={false} notFoundClass="hide" />
		<br />
	</section>
	<section class="section lista-imoveis pt-0 {numberOfItemsForSell == 0 ? 'hide':''}">
		{#if numberOfItemsForSell > 0}
		<h3>Imóveis para comprar</h3>
		{/if}
		<ListaImoveis holderClass="grid grid-size--3 grid-size-md--3 grid-size-sm--2 grid-size-xs--1" colClass="item" filters={filtrosSell} afterLoadRealties={afterLoadRealties} showPaginator={false} notFoundClass="hide" />
	</section>
{:else}
		<p>Você não tem nenhum imóvel marcado como favorito.<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /></p>
{/if}
</div>